/* iPhumat — révélation douce des sections au scroll.
 * Progressive enhancement : sans JS, tout reste visible.
 * Respecte prefers-reduced-motion.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Sur mobile (< 760px) : on bypasse l'animation au scroll. Les éléments
  // sont visibles d'office, plus de saccades qui rendaient l'écran ouf.
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
  function run() {
    var targets = document.querySelectorAll('.reveal');
    if (reduce || isMobile || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
